// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Zustand from "zustand";

const context = React.createContext(undefined);

function useStore(param) {
  return Stdlib__Option.get(React.useContext(context));
}

function useAppStore(selector) {
  return Zustand.useStore(Stdlib__Option.get(React.useContext(context)), selector);
}

const make = context.Provider;

const ProviderInternal = {
  make: make
};

function Context$Provider(Props) {
  let children = Props.children;
  let store = Props.store;
  return JsxRuntime.jsx(make, {
    value: Caml_option.some(store),
    children: children
  });
}

const Provider = {
  make: Context$Provider
};

function Context$Consumer(Props) {
  let children = Props.children;
  let selector = Props.selector;
  return Curry._1(children, Zustand.useStore(Stdlib__Option.get(React.useContext(context)), selector));
}

const Consumer = {
  make: Context$Consumer
};

export {
  context,
  useStore,
  useAppStore,
  ProviderInternal,
  Provider,
  Consumer,
}
/* context Not a pure module */
